export default __webpack_public_path__ + "assets/images/b6c91be486feb52884ff62527bdc5fdc.svg";